import usePwaInstall from "../../hooks/usePwaInstall";
import MaterialIcon from "../../oversight-core/ui-elements/material-icon/material-icon";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../oversight-core/utils/toast";
import styles from "./install-app-card.module.scss";

interface IProps {
  collapsed?: boolean;
}

const InstallAppCard = ({ collapsed = false }: IProps) => {
  const { isInstalled, canPrompt, isIos, install } = usePwaInstall();

  if (isInstalled || (!canPrompt && !isIos)) {
    return null;
  }

  const handleInstall = async () => {
    if (canPrompt) {
      const outcome = await install();
      if (outcome === "accepted") {
        showSuccessMessage("App installed successfully");
      }
      return;
    }

    if (isIos) {
      showWarningMessage("Tap Share, then Add to Home Screen to install");
      return;
    }

    showWarningMessage(
      "Use your browser's install option, or try again in a moment",
    );
  };

  if (collapsed) {
    return (
      <button
        type="button"
        className={styles.collapsedButton}
        onClick={handleInstall}
        title="Install app"
        aria-label="Install app"
      >
        <MaterialIcon icon="download_2" size={18} color="#69768B" />
      </button>
    );
  }

  return (
    <button type="button" className={styles.card} onClick={handleInstall}>
      <MaterialIcon icon="download_2" size={18} color="#69768B" />
      <div className={styles.copy}>
        <span className={styles.title}>Install app</span>
        <span className={styles.subtitle}>Add to your device</span>
      </div>
    </button>
  );
};

export default InstallAppCard;
